import { http, pagination } from 'utils'
import { SET_ITEMS, ADD_ITEMS, SET_META, REMOVE_ITEM, UPDATE_STATION, UPDATE_SIZE, UPDATE_PRODUCT, UPDATE_FIREFIGHTER,
  UPDATE_REQUEST, UPDATE_REQUESTS
} from 'vx/mutations'
import { concat, set } from 'lodash'

export default {
  namespaced: true,

  state: {
    requests: [],
    meta: null
  },

  actions: {
    async getRequests ({ commit, state }, { params = {} } = {}) {
      if (state.meta) {
        if (pagination(state.meta)) {
          return Promise.reject(new Error('No more results.'))
        }

        params.page = state.meta.current_page + 1
      }

      const response = await http.get('replenishment-requests', { params })

      commit(ADD_ITEMS, response.data.data)
      commit(SET_META, response.data.meta)

      return response
    },

    async updateSize ({ commit }, { size, requestId }) {
      await http.post(`replenishment-requests/${requestId}/size`, { size_id: size.id })
      commit(UPDATE_SIZE, { request: requestId, size: size })
    },

    async updateProduct ({ commit }, { product, size, requestId }) {
      await http.post(`replenishment-requests/${requestId}/product`, { product_id: product.id, size_id: size.id })
      commit(UPDATE_PRODUCT, { request: requestId, product: product, size: size })
    },

    async updateStation ({ commit }, { station, requestId }) {
      await http.post(`replenishment-requests/${requestId}/station`, { station_id: station.id })
      commit(UPDATE_STATION, { request: requestId, station: station })
    },

    async updateFirefighter ({ commit }, { firefighter, requestId }) {
      await http.post(`replenishment-requests/${requestId}/firefighter`, { firefighter_id: firefighter.id })
      commit(UPDATE_FIREFIGHTER, { request: requestId, firefighter: firefighter })
    },

    async assignAndPrint ({ commit }, { requestId, ignoreSize, product }) {
      const response = await http.post(`replenishment-requests/${requestId}/print`, { ignore_size: ignoreSize, product: product })

      commit(UPDATE_REQUEST, response.data.data)
    },

    async rePrint ({ commit }, { requestId, ignoreSize, product }) {
      const response = await http.post(`replenishment-requests/${requestId}/reprint`, { ignore_size: ignoreSize, product: product })

      return (UPDATE_REQUEST, response.data.data)
    },

    async assign ({ commit }, { requestId, ignoreSize, product }) {
      const response = await http.post(`replenishment-requests/${requestId}/assign`, { ignore_size: ignoreSize, product: product })

      commit(UPDATE_REQUEST, response.data.data)
    },

    async bulkAssign ({ commit }, { requestIds, product }) {
      const response = await http.post(`replenishment-requests/bulk-assign`, { product: product, request_ids: requestIds })

      commit(UPDATE_REQUESTS, response.data.data)

      return response
    },

    async bulkAssignAndPrint ({ commit }, { requestIds, product }) {
      const response = await http.post(`replenishment-requests/bulk-assign-and-print`, { product: product, request_ids: requestIds })

      commit(UPDATE_REQUESTS, response.data.data)

      return response
    },

    resetRequests ({ commit }) {
      commit(SET_ITEMS, [])
      commit(SET_META, null)
    },

    removeRequest ({ commit }, { id }) {
      commit(REMOVE_ITEM, id)
    },

    async deleteReplenishmentRequest ({ commit }, { requestId }) {
      const response = await http.delete(`replenishment-requests/${requestId}`)

      return response
    },

    async updateNdr ({ commit }, { requestId }) {
      const response = await http.post(`replenishment-requests/${requestId}/ndr`)

      commit(UPDATE_REQUEST, response.data.data)

      return response
    },

    async bulkUpdateNdr ({ commit }, { requestIds }) {
      const response = await http.post(`replenishment-requests/bulk-update-ndr`, { request_ids: requestIds })

      commit(UPDATE_REQUESTS, response.data.data)

      return response
    },

    async bulkUpdatePurchaseOrderId ({ commit }, { purchaseOrderId, requestIds }) {
      const response = await http.post(`replenishment-requests/bulk-update-purchase-order-id`, { purchase_order_id: purchaseOrderId, request_ids: requestIds })

      commit(UPDATE_REQUESTS, response.data.data)

      return response
    },

    async bulkUpdateEstimatedDispatchDate ({ commit }, { estimatedDispatchDate, requestIds }) {
      const response = await http.post(`replenishment-requests/bulk-update-estimated-dispatch-date`, { estimated_dispatch_date: estimatedDispatchDate, request_ids: requestIds })

      commit(UPDATE_REQUESTS, response.data.data)

      return response
    },

    async updateEstimatedDispatchDate ({ commit }, { requestId, estimatedDispatchDate }) {
      const response = await http.post(`replenishment-requests/${requestId}/eta`, { estimated_dispatch_date: estimatedDispatchDate })

      commit(UPDATE_REQUEST, response.data.data)

      return response
    },

    async updateComment ({ commit }, { comment, requestId }) {
      const response = await http.post(`replenishment-requests/${requestId}/comment`, { comment: comment })

      commit(UPDATE_REQUEST, response.data.data)

      return response
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.requests = items
    },

    [ADD_ITEMS] (state, items) {
      state.requests = concat(state.requests, items)
    },

    [SET_META] (state, meta) {
      state.meta = meta
    },

    [REMOVE_ITEM] (state, id) {
      const req = state.requests.findIndex(item => item.id === id)
      state.requests.splice(req, 1)
    },

    [UPDATE_STATION] (state, { request, station }) {
      const req = state.requests.find(item => item.id === request)
      set(req, 'station', station)
    },

    [UPDATE_SIZE] (state, { request, size }) {
      const req = state.requests.find(item => item.id === request)
      set(req, 'size', size)
    },

    [UPDATE_PRODUCT] (state, { request, product, size }) {
      const req = state.requests.find(item => item.id === request)
      set(req, 'product', product)
      set(req, 'size', size)
    },

    [UPDATE_FIREFIGHTER] (state, { request, firefighter }) {
      const req = state.requests.find(item => item.id === request)
      set(req, 'firefighter', firefighter)
    },

    [UPDATE_REQUEST] (state, request) {
      const req = state.requests.find(item => item.id === request.id)
      if (req) {
        Object.assign(req, request)
      }
    },

    [UPDATE_REQUESTS] (state, requests) {
      requests.forEach((request) => {
        const req = state.requests.find(item => item.id === request.id)
        if (req) {
          Object.assign(req, request)
        }
      })
    }
  }
}
